// Tower 11 (ES CON FIELD) properties. `aos_demo` is the staging/demo twin of
// `tower11_hotel`, so both slugs are treated as Tower 11 throughout the app.
export const TOWER_ELEVEN_PROPERTIES = ['tower11_hotel', 'aos_demo'] as const

export type TowerElevenProperty = (typeof TOWER_ELEVEN_PROPERTIES)[number]

export const isTowerEleven = (
  property?: string
): property is TowerElevenProperty =>
  TOWER_ELEVEN_PROPERTIES.includes(property as TowerElevenProperty)
